import React from 'react';
import './Form.css';
const Form = ({ children, onSubmit, className }) => {
    return (
        <form className={`${className} form`} onSubmit={onSubmit}>
            {children}
        </form>
    );
};

export default Form;
